import CheckPermissions from './CheckPermissions';

export default CheckPermissions;
